import * as types from 'store/types'

const initialState = {
  subscription: {},
  is_subscribed: false,
  is_subscription_loaded: false,
  isSubmittingCard: false,
  isSubmittingSubscription: false,
  showCardModal: false,
  showCheckoutModal: false,
  showSubscriptionSuccessModal: false,
  showInvoicesModal: false,
  showResumePlanModal: false,
  invoices: [],
  invoice_fetching: false,
  showOnboardingPlansPopup: false,
  showCreateItemPopup: false,
  isUpgradeStep4: false
}
const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_SUBSCRIPTION: {
      return initialState
    }
    case types.SHOW_ONBOARDING_PLANS_POPUP: {
      return {
        ...state,
        showOnboardingPlansPopup: action.status || false
      }
    }
    case types.SHOW_CREATE_ITEMS_POPUP: {
      return {
        ...state,
        showCreateItemPopup: action.status || false
      }
    }
    case types.SET_ACTIVE_SUBSCRIPTION: {
      return {
        ...state,
        subscription: action.data ? { ...action.data } : {},
        is_subscribed: action.data ? action.data.is_subscribed : false,
        is_subscription_loaded: true
      }
    }
    case types.TOGGLE_SUBMITTING_CARD: {
      return {
        ...state,
        isSubmittingCard: action.value || false
      }
    }
    case types.TOGGLE_SUBMITTING_SUBSCRIPTION: {
      return {
        ...state,
        isSubmittingSubscription: action.value || false
      }
    }
    case types.TOGGLE_CARD_MODAL: {
      return {
        ...state,
        showCardModal: action.value || false
      }
    }
    case types.TOGGLE_CHECKOUT_MODAL: {
      return {
        ...state,
        showCheckoutModal: action.value || false,
        isUpgradeStep4: action.isUpgradeStep4 || false
      }
    }
    case types.TOGGLE_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        showSubscriptionSuccessModal: action.value || false,
        isUpgradeStep4: false
      }
    }
    case types.TOGGLE_RESUMEPLAN_MODAL: {
      return {
        ...state,
        showResumePlanModal: action.value || false
      }
    }
    case types.TOGGLE_INVOICE_FETCHING: {
      return {
        ...state,
        invoice_fetching: action.value || false
      }
    }
    case types.TOGGLE_INVOICES_MODAL: {
      return {
        ...state,
        showInvoicesModal: action.value || false
      }
    }
    case types.SET_INVOICES: {
      return {
        ...state,
        invoices: action.data || [],
        invoice_fetching: false
      }
    }
    default: {
      return { ...state }
    }
  }
}
export default subscriptionReducer
